
export const comparisonProducts = [
  {
    id: 'cp1',
    name: '스테인리스 와이어 로프',
    category: '어구류',
    manufacturer: '부산해양산업',
    price: '₩85,000/100m',
    image: 'https://public.readdy.ai/ai/img_res/eee213267d0bcbb9953bf01638679e5b.jpg',
    material: '316 스테인리스강',
    specification: '직경 12mm, 7x19 구조',
    certification: 'KS D 3514 인증',
    deliveryTime: '3-5일',
    warranty: '1년'
  },
  {
    id: 'cp2',
    name: '프리미엄 와이어 로프',
    category: '어구류',
    manufacturer: '보령해양기자재',
    price: '₩92,000/100m',
    image: 'https://readdy.ai/api/search-image?query=premium-marine-grade-wire-rope-with-galvanized-finish-neatly-coiled-showing-superior-braiding-pattern-and-corrosion-resistant-coating-on-neutral-white-surface-industrial-maritime-supply-product-shot&width=400&height=400&seq=cp2&orientation=squarish',
    material: '304 스테인리스강',
    specification: '직경 12mm, 6x19 구조',
    certification: 'ISO 9001, KS 인증',
    deliveryTime: '5-7일',
    warranty: '2년'
  },
  {
    id: 'cp3',
    name: '경제형 와이어 로프',
    category: '어구류',
    manufacturer: '목포수산기자재',
    price: '₩68,000/100m',
    image: 'https://readdy.ai/api/search-image?query=economical-marine-wire-rope-with-zinc-coating-displayed-in-neat-coil-form-showing-standard-industrial-braiding-on-plain-white-backdrop-cost-effective-fishing-vessel-equipment-commercial-photography&width=400&height=400&seq=cp3&orientation=squarish',
    material: '아연도금강',
    specification: '직경 12mm, 6x7 구조',
    certification: 'KS 인증',
    deliveryTime: '2-4일',
    warranty: '6개월'
  },
  {
    id: 'cp4',
    name: '대형 스테인리스 샤클',
    category: '갑판용품',
    manufacturer: '여수해양공업',
    price: '₩45,000/개',
    image: 'https://readdy.ai/api/search-image?query=heavy-duty-stainless-steel-shackle-with-screw-pin-showing-polished-metallic-surface-and-robust-construction-on-clean-white-background-professional-marine-hardware-product-photography&width=400&height=400&seq=cp4&orientation=squarish',
    material: '316 스테인리스강',
    specification: '25mm, 하중 5톤',
    certification: 'ISO 9001, CE 인증',
    deliveryTime: '3-5일',
    warranty: '2년'
  },
  {
    id: 'cp5',
    name: '중형 샤클',
    category: '갑판용품',
    manufacturer: '통영기계공업',
    price: '₩38,000/개',
    image: 'https://readdy.ai/api/search-image?query=medium-size-marine-shackle-with-bolt-pin-featuring-galvanized-finish-and-industrial-grade-construction-displayed-on-neutral-white-surface-commercial-deck-equipment-product-shot&width=400&height=400&seq=cp5&orientation=squarish',
    material: '304 스테인리스강',
    specification: '22mm, 하중 4톤',
    certification: 'KS 인증',
    deliveryTime: '4-6일',
    warranty: '1년'
  },
  {
    id: 'cp6',
    name: '표준형 샤클',
    category: '갑판용품',
    manufacturer: '포항철강산업',
    price: '₩28,000/개',
    image: 'https://readdy.ai/api/search-image?query=standard-marine-shackle-with-safety-pin-showing-durable-steel-construction-and-zinc-plating-on-plain-white-background-economical-fishing-vessel-hardware-commercial-photography&width=400&height=400&seq=cp6&orientation=squarish',
    material: '탄소강 아연도금',
    specification: '20mm, 하중 3톤',
    certification: 'KS 인증',
    deliveryTime: '2-3일',
    warranty: '1년'
  }
];
